const escapeHtml = (value = '') =>
  String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const SAFE_URL_PATTERN = /^(https?:|mailto:|tel:|\/|#)/i;

const getStyle = (node) => node.getAttribute?.('style') || '';

const wrapStyledSpan = (node, html) => {
  const style = getStyle(node);
  let output = html;

  if (/font-weight\s*:\s*(bold|[6-9]00)/i.test(style)) {
    output = `<strong>${output}</strong>`;
  }
  if (/font-style\s*:\s*italic/i.test(style)) {
    output = `<em>${output}</em>`;
  }
  if (/text-decoration[^;]*underline/i.test(style)) {
    output = `<u>${output}</u>`;
  }

  return output;
};

const sanitizeNode = (node) => {
  if (node.nodeType === Node.TEXT_NODE) {
    return escapeHtml(node.textContent);
  }

  if (node.nodeType !== Node.ELEMENT_NODE) {
    return '';
  }

  const tagName = node.tagName.toLowerCase();
  const children = Array.from(node.childNodes).map(sanitizeNode).join('');

  switch (tagName) {
    case 'br':
      return '<br>';
    case 'b':
    case 'strong':
      return `<strong>${children}</strong>`;
    case 'i':
    case 'em':
      return `<em>${children}</em>`;
    case 'u':
      return `<u>${children}</u>`;
    case 'ul':
      return `<ul>${children}</ul>`;
    case 'ol':
      return `<ol>${children}</ol>`;
    case 'li':
      return `<li>${children || '<br>'}</li>`;
    case 'p':
      return `<p>${children || '<br>'}</p>`;
    case 'div':
      return children ? `<p>${children}</p>` : '';
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
    case 'h6':
      return `<p><strong>${children}</strong></p>`;
    case 'a': {
      const href = node.getAttribute('href') || '';
      if (!SAFE_URL_PATTERN.test(href)) return children;
      return `<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer">${children}</a>`;
    }
    case 'span':
      return wrapStyledSpan(node, children);
    default:
      return children;
  }
};

export const sanitizeRichTextHtml = (value = '') => {
  if (!value) return '';

  if (typeof document === 'undefined') {
    return escapeHtml(value).replace(/\r?\n/g, '<br>');
  }

  const template = document.createElement('template');
  template.innerHTML = String(value).replace(/\r?\n/g, '<br>');
  return Array.from(template.content.childNodes).map(sanitizeNode).join('').trim();
};

export const richTextToPlainText = (value = '') => {
  if (!value) return '';

  if (typeof document === 'undefined') {
    return String(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  const container = document.createElement('div');
  container.innerHTML = sanitizeRichTextHtml(value);
  return container.textContent.replace(/\s+/g, ' ').trim();
};
